import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface CellTab {
  id: string;
  label: string;
}

interface HeroStat {
  label: string;
  value: string;
}

interface CellPoint {
  title: string;
  description: string;
}

interface WomenCellMember {
  sno: number;
  name: string;
  designation: string;
}

@Component({
  selector: 'app-blog-grid-page',
  templateUrl: './blog-grid-page.component.html',
  styleUrls: ['./blog-grid-page.component.scss']
})
export class BlogGridPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  pageTitle = 'Institutional Development Cells';
  pageSubtitle =
    'Creating a safe, inclusive, and empowering academic environment through dedicated institutional support cells.';

  admissionNotice =
    'Admissions open for 2026 : B.E (CIVIL), B.E (CSE), B.E (CSE - AI & ML), B.E (CSE - CS), B.E (ECE), B.E (EEE), B.E (MECH), MBA, M.E (CSE), M.E (Embedded System Technologies), M.E (Thermal Engineering).';

  tabs: CellTab[] = [
    { id: 'tab1', label: 'Women Empowerment Cell' }
  ];

  heroStats: HeroStat[] = [
    { label: 'Support', value: 'Women Empowerment' },
    { label: 'Focus', value: 'Safety & Inclusion' },
    { label: 'Growth', value: 'Leadership & Skills' },
    { label: 'Care', value: 'Guidance & Well-being' }
  ];

  womenIntro: string[] = [
    'The Women’s Cell of FMCET serves as a dedicated platform to address the needs, concerns, and well-being of female students and staff.',
    'Its primary function is to create a safe and inclusive environment for women within the institution. The cell plays an important role in awareness, protection, counselling, empowerment, and professional growth.'
  ];

  womenPoints: CellPoint[] = [
    {
      title: 'Gender Sensitization',
      description:
        'The Women’s Cell conducts workshops, seminars, and awareness programs to sensitize the college community to gender issues, stereotypes, and the importance of gender equality.'
    },
    {
      title: 'Preventing Harassment',
      description:
        'The cell plays a pivotal role in preventing and addressing any form of harassment or discrimination against women within the college premises. It ensures the implementation of policies and guidelines related to preventing sexual harassment.'
    },
    {
      title: 'Support and Counseling',
      description:
        'The Women’s Cell provides a supportive space where female students and staff can seek counseling, guidance, and assistance on personal, academic, or professional matters.'
    },
    {
      title: 'Safety and Security',
      description:
        'The cell works to enhance the safety and security of women on campus, addressing concerns related to lighting, transportation, and overall campus infrastructure.'
    },
    {
      title: 'Awareness Programs',
      description:
        'It organizes awareness campaigns on issues such as women’s health, menstrual hygiene, self-defense, and legal rights to empower women with knowledge.'
    },
    {
      title: 'Career Development',
      description:
        'It offers workshops and seminars focused on career development, leadership skills, and opportunities in the engineering field to help women grow in their chosen careers.'
    },
    {
      title: 'Mentorship Programs',
      description:
        'It facilitates mentorship programs where senior female students or faculty members mentor and guide junior female students, offering academic and career guidance.'
    },
    {
      title: 'Celebrate Achievements',
      description:
        'It acknowledges and celebrates the achievements of women in various fields, both within the college and beyond, to inspire and motivate others.'
    },
    {
      title: 'Liaison with Authorities',
      description:
        'It serves as a link between female students and faculty and the college administration, ensuring that their concerns are heard and addressed appropriately.'
    },
    {
      title: 'Resource Center',
      description:
        'It maintains a resource center with information related to women’s rights, career opportunities, scholarships, and other relevant resources.'
    },
    {
      title: 'Work-Life Balance',
      description:
        'It organizes workshops on achieving work-life balance, managing stress, and promoting overall well-being.'
    },
    {
      title: 'Empowerment Workshops',
      description:
        'It organizes workshops to enhance self-confidence, communication skills, negotiation skills, and assertiveness among female students.'
    },
    {
      title: 'Networking',
      description:
        'It facilitates networking events where female students can connect with alumnae, industry professionals, and role models.'
    }
  ];

  womenCellMembers: WomenCellMember[] = [
    { sno: 1, name: 'Mrs. P. Geetha', designation: 'AP / MBA' },
    { sno: 2, name: 'Dr. Vasanthi', designation: 'ASP / S&H' },
    { sno: 3, name: 'Ms. P. Jebane', designation: 'AP / ECE' },
    { sno: 4, name: 'Mrs. M. Aishwarya', designation: 'AP / EEE' },
    { sno: 5, name: 'Mrs. Aparna Preethi K', designation: 'AP / CSE (CYBER)' },
    { sno: 6, name: 'Mrs. Shyni B S', designation: 'AP / MECH' },
    { sno: 7, name: 'Ms. M. Kamalisri', designation: 'IV CSE' },
    { sno: 8, name: 'Ms. M. Bhairavi', designation: 'IV CSE' },
    { sno: 9, name: 'Ms. A. Aliya Fatima', designation: 'IV ECE' },
    { sno: 10, name: 'Ms. J. Kavipriya', designation: 'IV ECE' }
  ];

  womenClosing =
    'Overall, the Women’s Cell plays a crucial role in ensuring that women have a supportive and empowering environment where they can thrive academically, professionally, and personally.';

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Institutional Development Cells';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  ngOnInit(): void {}
}